import { createFileRoute } from '@tanstack/react-router'
import { InboxList } from '@/features/inbox/InboxList'
import { QuickCapture } from '@/features/inbox/QuickCapture'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/inbox')({
  component: InboxPage,
})

function InboxPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Inbox" />
      <div className="mt-6">
        <QuickCapture autoFocus />
      </div>
      <div className="mt-6">
        <InboxList />
      </div>
    </div>
  )
}
